module.exports = __webpack_public_path__ + "img/ctorcircle.0279a775.png";